import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import CustomDialog from "../CustomDialog";
import { useQueryClient } from "@tanstack/react-query";
import { fichiersService } from "../../services";
import showToast from "../Toast";


interface IModalEditFichierProps {
  modalIsOpen: boolean;
  closeModal: () => void;
  selectedFichier: any;
  setLoading?: (value: boolean) => void;
}

const ModalEditFichier = ({
  modalIsOpen,
  closeModal,
  selectedFichier,
  setLoading,
}: IModalEditFichierProps) => {
  const queryClient = useQueryClient();

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
  } = useForm();

  // ✅ remplir form avec fichier sélectionné
  useEffect(() => {
    if (selectedFichier) {
      setValue("nom", selectedFichier.nom_fichier || "");
      setValue("description", selectedFichier.description || "");
    }
  }, [selectedFichier, setValue]);

  // ✅ submit
  const onSubmit = async (data) => {
    try {
      setLoading && setLoading(true);
      await fichiersService.renommerFichier({
      file_id: selectedFichier.id,
      nom: data.nom,
      description: data.description,
    });
      showToast("success", "Nom du fichier modifié avec succès");
      queryClient.refetchQueries({
        queryKey: ["fichiers"],
      });
      reset();
      closeModal();
    } catch (e) {
      console.error(e);
      showToast("error", "Erreur lors de la modification");
    } finally {
      setLoading && setLoading(false);
    }
  };

  return (
    <CustomDialog
      header="Modifier fichier"
      visible={modalIsOpen}
      closeModalDialog={() => {
        reset();
        closeModal();
      }}
    >
      <div className="w-full h-full">
        <div className="p-6 space-y-6">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="grid grid-cols-6 gap-6 mb-2">
              
              <div className="col-span-6">
                <label className="block text-md font-bold text-gray-900">
                  Nom du fichier *
                </label>

                <input
                  type="text"
                  placeholder="Saisir nom fichier"
                  className="my-3 border border-gray-300 text-gray-900 font-semibold text-md rounded-lg block w-full p-2.5"
                  {...register("nom", { required: true })}
                />

                {errors.nom && (
                  <span className="bg-red-100 text-red-800 text-md px-2.5 py-0.5 rounded">
                    champs obligatoire
                  </span>
                )}
              </div>
              <div className="col-span-6">
                <label className="block text-md font-bold text-gray-900">
                  Description
                </label>

                <textarea
                  placeholder="Saisir une description"
                  rows={3}
                  className="my-3 border border-gray-300 text-gray-900 font-semibold text-md rounded-lg block w-full p-2.5"
                  {...register("description")}
                />
              </div>
            </div>

            <div className="flex justify-end mt-6">
              <button
                type="submit"
                className="text-white bg-gexpertise-200 hover:bg-gexpertise-100 font-medium rounded-lg text-md px-6 py-3"
              >
                Modifier
              </button>
            </div>
          </form>
        </div>
      </div>
    </CustomDialog>
  );
};

export default ModalEditFichier;